import { createMuiTheme } from '@material-ui/core/styles';

import Colors from './colors';
import Fonts from './fonts';

const palette = {
  primary: { main: Colors.primary, contrastText: Colors.light },
  secondary: { main: Colors.secondary, contrastText: Colors.primary },
  dark: { main: Colors.success, contrastText: Colors.light },
  darkGrey: { main: Colors.success, contrastText: Colors.light },
  light: { main: Colors.light, contrastText: Colors.primary },
  success: { main: Colors.success, contrastText: Colors.light },
  error: { main: Colors.error, contrastText: Colors.light },
  warning: { main: Colors.warning, contrastText: Colors.light },
};

const typography = {
  fontFamily: 'Regular, sans-serif',
  fontSize: 12,
};

export default createMuiTheme({
  palette,
  typography,
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [Fonts.Regular],
      },
    },
  },
});
